export default __webpack_public_path__ + "static/media/PASMAlogo2.9a27a6ca.png";